<template>
  <DxPopup
    :visible="showPopup"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    :width="popupWidth"
    :height="'auto'"
    :min-height="'150px'"
    :max-height="'80%'"
    :title="title || 'Information'"
    @hidden="onHide"
    :show-close-button="false"
    @shown="onShown"
  >
    <DxScrollView
      id="scrollview"
      ref="scrollViewWidget"
      :scroll-by-content="true"
      :scroll-by-thumb="true"
      :show-scrollbar="'onScroll'"
      class="gc-popup-validation-summary-scroll-view"
    >
      <DxValidationSummary
        :items="items"
        :validation-group="validationGroup"
        :ref="'mainValidationSummary'"
      />
    </DxScrollView>
    <div class="gc-popup-validation-summary-button-row">
      <DxButton
        :text="backButtonText ? backButtonText : 'BACK'"
        type="default"
        styling-mode="contained"
        @click="clickOnBackButton"
        :ref="'default-back-btn'"
      />
    </div>
  </DxPopup>
</template>
<script>
import { DxPopup } from "devextreme-vue/popup";
import DxValidationSummary from "devextreme-vue/validation-summary";
export default {
  name: "GcPopupValidationSummary",
  props: [
    "showPopup",
    "validationGroup",
    "title",
    "isXSmall",
    "items",
    "backButtonText",
    "onHidden",
  ],
  watch: {
    items(value) {
      // eslint-disable-next-line no-console
      // this.$logger.debug("Validation summary watched:", value);
      this.$refs["mainValidationSummary"].instance.items = value;
    },
  },
  components: {
    DxPopup,
    DxValidationSummary,
  },
  methods: {
    onHide(e) {
      if (e.event) e.event.preventDefault();

      this.$store.dispatch("ui/setServerError", false);
      // this.$emit("update:items", []);
      this.$store.dispatch("ui/setValidationSummaryVisible", false);
      if (this.onHidden) this.onHidden();
    },
    clickOnBackButton() {
      this.$emit("update:showPopup", false);
    },
    onShown() {
      this.$store.dispatch("ui/setValidationSummaryVisible", true);

      this.$refs["default-back-btn"].instance.focus();
    },
  },
  computed: {
    popupWidth() {
      return this.isXSmall ? "80vw" : "50vw";
    },
  },
};
</script>

<style lang="scss">
.dx-validationsummary-item {
  color: black !important;
}

.dx-validationsummary-item-content {
  border-bottom: none !important;
  font-size: 14px;
}

.gc-popup-validation-summary-button-row {
  // position: absolute;
  // bottom: 16px;
  // right: 16px;
  // height: 45px;
  // width: 95%;
  display: flex;
  justify-content: flex-end;
}

.gc-popup-validation-summary-scroll-view {
  margin-bottom: -20px;
  padding-bottom: 25px;
}
</style>
